import { I18NextPipe } from 'angular-i18next';
import { AgentType } from 'mbs-ui-shared@models/Computer';

export const getProductTilesConfig = (i18N: I18NextPipe) => [
  {
    id: AgentType.Backup,
    title: i18N.transform('shared:products.backup'),
    description: i18N.transform('shared:computers.addComputerWizard.actionStep.backupDescription'),
    icon: 'mbs-agent mbs-agent-md mbs-agent_backup'
  },
  {
    id: AgentType.RMM,
    title: i18N.transform('shared:products.rmm'),
    description: i18N.transform('shared:computers.addComputerWizard.actionStep.rmmDescription'),
    icon: 'mbs-agent mbs-agent-md mbs-agent_rmm'
  },
  {
    id: AgentType.RA,
    title: i18N.transform('shared:products.ra'),
    description: i18N.transform('shared:computers.addComputerWizard.actionStep.raDescription'),
    icon: 'mbs-agent mbs-agent-md mbs-agent_connect'
  }
];
